import React, { useContext } from 'react';
import { TooltipContext } from '../providers/TooltipContext';

const InfoTooltip = ({ tooltipTextKey, color = '#cacaca' }) => {
    const tooltips = useContext(TooltipContext);
    const tooltipText = tooltips[tooltipTextKey] || 'Loading...';

    return (
        <div className="ml-1" style={{ display: 'inline-flex', alignItems: 'center' }}>
            <i
                className="fa-solid fa-circle-info"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title={tooltipText}
                style={{ cursor: 'pointer', fontSize: '12px', color: color }}
            ></i>
        </div>
    );
};

export default InfoTooltip;